export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const findCategory = (categories: any, category_id: any) => {
    for (let category of categories) {
        if (category.id === category_id) {
            return category;
        }
        if (category.children && category.children.length > 0) {
            const found = findCategory(category.children, category_id);
            if (found) {
                return found;
            }
        }
    }
    return null;
};

export const PLAIN_TEXT_LENGTH = 2000;